$(function(){
    $('#meterials .collapse').collapse('hide');
});
